import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    position: 'relative',
    width: '100%',
  },
  resultsMessage: {
    fontWeight: 600,
    maxWidth: pxToRem(420),
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  noResultsSentence: {
    fontWeight: 400,
  },
  resultsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: pxToRem(1204),
    paddingTop: pxToRem(20),
  },
  moduleHeader: {
    margin: `${pxToRem(18)} ${pxToRem(24)} ${pxToRem(32)}`,
    borderBottom: `${pxToRem(2)} solid ${theme.palette.neutralTertiaryAlt}`,
  },
  moduleContent: {
    padding: `0 ${pxToRem(24)} ${pxToRem(32)} ${pxToRem(24)}`,
  },
  moduleIndentedContent: {
    display: 'block',
    paddingLeft: pxToRem(16),
    paddingRight: pxToRem(16),
  },
  statementPortalText: {
    fontSize: pxToRem(12),
    lineHeight: pxToRem(16),
    fontWeight: 400,
    color: theme.palette.neutralSecondary,
  },
  infoMessage: {
    display: 'flex',
    alignItems: 'flex-start',
    color: theme.palette.neutralSecondary,
    paddingTop: pxToRem(10),
  },
  infoIcon: {
    position: 'relative',
    marginRight: pxToRem(6),
    color: theme.palette.neutralTertiary,
  },
  infoText: {
    fontSize: pxToRem(12),
    lineHeight: pxToRem(16),
    fontWeight: 400,
  },
  iframeContainer: {
    position: 'relative',
    overflow: 'hidden',
    paddingTop: '56.25%',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  fullWidthLimit: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    maxWidth: pxToRem(1204),
    margin: '0 auto',
  },
  searchSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    paddingBottom: pxToRem(25),
  },
  slash: {
    color: theme.palette.neutralQuaternaryAlt,
  },
  searchFieldsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: pxToRem(1204),
  },
  filterAndSearchContainer: {
    display: 'flex',
    marginTop: '15px',
    maxWidth: pxToRem(468),
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
  addSearchFieldButton: {
    marginTop: '15px',
  },
  filter: {
    maxWidth: pxToRem(223),
    width: pxToRem(156),
    selectors: {
      '& span': {
        borderWidth: 0,
        borderRadius: 0,
        borderBottomColor: theme.palette.themePrimary,
        borderBottomWidth: pxToRem(1),
        fontWeight: 'normal',
      },
    },
  },
  search: {
    maxWidth: pxToRem(320),
    width: pxToRem(312),
    selectors: {
      '&::before': {
        content: '" "',
        position: 'absolute',
        height: '70%',
        width: pxToRem(1),
        top: '15%',
        left: '-1px',
        backgroundColor: theme.palette.neutralQuaternary,
      },
    },
  },
  andText: {
    marginTop: '20px',
    fontWeight: 'normal',
  },
  selectDeselectButtonsContainer: {
    position: 'relative',
    right: '0',
  },
  bundleButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    maxWidth: pxToRem(1204),
  },
  textButton: {
    paddingRight: 0,
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
  },
  cancelButton: {
    marginRight: pxToRem(20),
    marginLeft: pxToRem(20),
    fontWeight: 400,
  },
  removeButton: {
    height: pxToRem(20),
    marginRight: pxToRem(20),
    marginLeft: pxToRem(20),
    fontWeight: 400,
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        position: 'absolute',
      },
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
      '&:active': {
        background: 'transparent',
      },
    },
  },
  iconColumnHeaderSelectButton: {
    cursor: 'pointer',
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        top: pxToRem(14),
        left: pxToRem(7),
        position: 'absolute',
      },
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
      '&:active': {
        background: 'transparent',
      },
      '& .ms-DetailsHeader-cellName .ms-Icon': {
        fontSize: pxToRem(16),
        color: theme.palette.themePrimary,
        paddingLeft: pxToRem(8),
      },
    },
  },
  viewButton: {
    textAlign: 'center',
    selectors: {
      a: {
        textDecoration: 'none',
        fontSize: pxToRem(14),
        selectors: {
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
  },
  selectButton: {
    top: pxToRem(1),
    left: pxToRem(8),
    height: 'auto',
  },
  selectedButton: {
    top: pxToRem(1),
    left: pxToRem(8),
    height: 'auto',
    opacity: 0.5,
  },
  breadcrumbs: {
    textDecoration: 'none',
    selectors: {
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  detailRowIconColor: {
    color: theme.palette.neutralTertiary,
  },
  countAndButtonsContainer: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'space-between',
  },
  productList: {
    selectors: {
      '& .ms-DetailsList-contentWrapper': {
        height: 'auto',
        maxHeight: pxToRem(450),
        overflowY: 'auto',
        overflowX: 'hidden',
      },
    },
  },
  productText: {
    width: pxToRem(320),
    fontSize: pxToRem(12),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
  },
  moreProductIds: {
    color: theme.palette.themePrimary,
  },
  tooltipContent: {
    margin: pxToRem(10),
    padding: pxToRem(15),
  },
});
